import { render, staticRenderFns } from "./MPopupUploadPost.vue?vue&type=template&id=57c07274&"
import script from "./MPopupUploadPost.ts?vue&type=script&lang=ts&"
export * from "./MPopupUploadPost.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports